// src/api/org/service.js
import { json } from "utils/http/client";

export const MaterialsApi = {
  // list all materials by site
  listAllMaterialsBySite: (data) =>
    json(`/inventory/get-materials-of-a-site/`, {
      method: "POST",
      body: data,
    }),

  transferMaterialToSite: (data) =>
    json(`/inventory/site-to-site-transfer/`, {
      method: "POST",
      body: data,
    }),
};
